module.exports = __webpack_public_path__ + "media/images/jd_w-5e237128be60c0e32a206f900e25412f.png";